exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rating-success-modal .driver-modal .perfect-rate[data-v-ca4e640a]{text-align:center}.rating-success-modal .driver-modal .perfect-rate p[data-v-ca4e640a]{color:#7a8189;font-weight:500;margin-top:20px}.rating-success-modal .btn-close[data-v-ca4e640a]{width:100%;height:45px;border:none;background:#ff8200;color:#fff;font-weight:500;font-size:14px;border-radius:4px;margin-top:20px;outline:none}", ""]);

// exports
